import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Heading,
  Button,
  TextField,
  DialogTrigger,
  Dialog,
  ActionButton,
  Divider,
  Content,
  Form,
  ButtonGroup,
  Item,
  Text,
  MenuTrigger,
  Menu,
  IllustratedMessage,
  ProgressCircle,
} from '@adobe/react-spectrum';
import actions from '../../config.json';
import OBJCODE from '../../constants';
import { actionWebInvoke } from '../../utils/actionCallUtils';

const FilesComponent = ({ user, ims }) => {
  const [wfFolders, setWfFolders] = useState('');

  const onFileChangeHandler = async e => {
    e.preventDefault();
    const file = e.target.files[0];
    console.log('file to upload', file);
    // await uploadToAEM3Step(getHeaders(ims), file, 'amex/test');
    // workfrontUpload(file);
  };

  async function getWfFoldersAndFiles(objCode, objID) {
    const fields = [
      'name',
      'lastModDate',
      'linkedFolderID',
      'linkedFolder:*',
      'parentID',
      'documents:name',
      'documents:lastModDate',
      'documents:downloadURL',
      'documents:previewURL',
      'children:name',
      'children:lastModDate',
      'children:linkedFolderID',
      'children:linkedFolder:*',
      'children:parentID',
    ];
    let queryParams;
    if (objCode === 'project') {
      queryParams = {
        projectID: objID,
      };
    } else if (objCode === 'task') {
      queryParams = {
        taskID: objID,
      };
    }
    const actionResponse = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.DOC_SEARCH, queryParams, fields },
    );
    setWfFolders(actionResponse);
    console.log('documents response', actionResponse);
  }

  return (
    <div>
      <h1>Files Component</h1>
      <DialogTrigger type="fullscreenTakeover">
        <Button UNSAFE_className="AddBoard" variant="primary">
          Upload to Workfront
        </Button>
        {close => (
          <Dialog>
            <Heading>Enter the name of the board you want to create</Heading>
            <Divider />
            <Content>
              <Form>
                <TextField
                  aria-label="textfield"
                  placeholder="Board Name"
                  width="750px"
                  onChange={setCurrentText}
                />
              </Form>
            </Content>
            <ButtonGroup>
              <Button variant="secondary" onPress={close}>
                Cancel
              </Button>
              <Button
                href="#/search"
                UNSAFE_className="dropdown-item"
                onPress={() => {
                  createUserBoards(state.currentText);
                  close();
                }}
              >
                Create board
              </Button>
            </ButtonGroup>
          </Dialog>
        )}
      </DialogTrigger>
      <input
        type="file"
        className="form-control"
        name="file"
        onChange={onFileChangeHandler}
      />
    </div>
  );
};

FilesComponent.propTypes = {
  user: PropTypes.string,
};

FilesComponent.defaultProps = {
  user: '',
};

export default FilesComponent;
